<template>
  <van-dialog title="意见反馈" @close="onClose">
    <div class="feedback" slot="main">
      <div class="success" v-if="isSubmitFeedbackSuccess">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/34798dca5168492e81363a0428d7b67b.png" alt="" />
        <p>提交成功，感谢您的反馈！</p>
      </div>
      <template v-else>
        <el-select
          popper-class="select-down"
          v-model="type"
          @change="changeType"
        >
          <el-option
            :label="item.name"
            :value="item.code"
            v-for="item in feedbackTypes"
            :key="item.code" />
        </el-select>
        <div class="textarea">
          <textarea v-model="opinion" maxlength="300" placeholder="请输入内容(300字以内)" />
          <span>{{opinion.length}}/300</span>
        </div>
        <img class="submit-feedback" @click="submitFeedback" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/4bf81f2618238e316e5ef9278c25d068.png" alt="" />
      </template>
    </div>
  </van-dialog>
</template>

<script>
/* eslint-disable */
import {
  Select,
  Option,
  Input,
} from 'element-ui';
import utils from '@/services/utils';
import api from '@/api/user';
import VanDialog from './Dialog.vue';

export default {
  props: {
  },
  components: {
    VanDialog,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
  },
  data() {
    return {
      type: '',
      opinion: '',
      feedbackTypes: [
        {
          name: '请选择问题类型',
          code: '',
        },
      ],
      isSubmitFeedbackSuccess: false,
    };
  },
  methods: {
    changeType() {

    },
    getFeedbackType() {
      api.getFeedbackType().then((data) => {
        this.feedbackTypes.push(...data);
      });
    },
    onClose() {
      this.$emit('close');
    },
    submitFeedback() {
      if (!this.type) {
        utils.error('请选择问题类型！');
        return
      }
      if (!this.opinion) {
        utils.error('未填写内容无法提交！');
        return
      }
      api.ideaFeedback({
        type: this.type,
        content: this.opinion,
      }).then((data) => {
        if (data) {
          this.isSubmitFeedbackSuccess = true;
        }
      })
    },
  },
  created() {
    this.getFeedbackType();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.feedback {
  padding: 0 2%;
  box-sizing: border-box;
  width: 54vw;
  height: 55vh;
  /deep/ .el-select {
    width: 30%;
    height: 10%;
    .is-focus {
      .el-input__inner {
        border-color: $primary;
      }
    }
    .el-input {
      height: 100%;
      .el-input__inner {
        &:focus {
          border-color: $primary;
        }
        height: 100%;
        text-align: center;
        color: $primary;
        font-size: 2.5vh;
        font-weight: 700;
        border-radius: 20px;
        box-shadow: 0px 0px 10px rgba(0, 56, 216, 0.3);
      }
      .el-input__suffix {
        .el-input__suffix-inner {
          .el-select__caret {
            font-size: 2vh;
            font-weight: 700;
            color: $primary;
          }
        }
      }
    }
  }
  .textarea {
    position: relative;
    margin-top: 2vh;
    height: 70%;
    textarea {
      padding: 5px 15px;
      line-height: 1.5;
      width: 100%;
      height: 100%;
      resize: none;
      box-sizing: border-box;
      font-size: 18px;
      &:focus {
        border: 1px solid #5A5FEF;
        outline: 0;
      }
    }
    span {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }
  .submit-feedback {
    margin-top: 2%;
    float: right;
    height: 12%;
    cursor: pointer;
    &:hover {
      opacity: .8;
    }
  }
  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 90%;
    img {
      width: 30%;
    }
    p {
      color: #5A5FEF;
      font-size: 2.5vh;
      text-align: center;
    }
  }
}
.select-down {
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-scrollbar__view {
        .selected {
          color: $primary;
        }
      }
    }
  }
}
</style>
